// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import BlogFormController from "./blog_form_controller.js"
application.register("blog-form", BlogFormController)

import BlogSnippetController from "./blog_snippet_controller.js"
application.register("blog-snippet", BlogSnippetController)

import DealsController from "./deals_controller.js"
application.register("deals", DealsController)

import FeedController from "./feed_controller.js"
application.register("feed", FeedController)

import FeedItemController from "./feed_item_controller.js"
application.register("feed-item", FeedItemController)

import ReportsController from "./reports_controller.js"
application.register("reports", ReportsController)

import ThemeController from "./theme_controller.js"
application.register("theme", ThemeController)

import TrancheController from "./tranche_controller.js"
application.register("tranche", TrancheController)
